import { r as registerInstance, h, a as Host } from './index-744b06c7.js';

const rCloseButtonCss = "r-close-button{display:block;position:relative}button{cursor:pointer;border:none;background:none;padding:0;margin:0}.button-container{width:48px;height:48px;align-content:center}.icon-close{width:16px;height:16px}.hover-state{transition:opacity 0.3s ease-in-out}@media (pointer: fine){.hover-state:hover{opacity:0.6}}";
const RCloseButtonStyle0 = rCloseButtonCss;

const RCloseButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleClose = undefined;
    }
    render() {
        return (h(Host, { key: '8a55f6d61fc1a6a9575fcc1c73c089262144a192' }, h("button", { key: '4992a29339eb536c485c56e2ae7ae2dd913f5c5a', class: "close-button hover-state", "aria-label": "Close", onClick: this.handleClose }, h("div", { key: '75ce09aedd449adf8794d2535f55e5e059e2e025', class: "button-container" }, h("img", { key: 'd5e7cb832f97cd653f073b72b8f15d8daba71292', class: "icon-close", src: "https://assets.ritual.com/icons/close-24x24.svg", alt: "Close" })))));
    }
};
RCloseButton.style = RCloseButtonStyle0;

export { RCloseButton as r_close_button };

//# sourceMappingURL=r-close-button.entry.js.map